<template>
    <div class="wrap-index">
        <header-app :index="1"></header-app>
        <div class="index-swiper">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide>
                    <div class="pages page-1 animation">
                        <div class="page-1-content">
                            <div class="page-text">
                                <p>GLOBAL</p>
                                <p>LEADERS IN </p>
                                <p>STRATEGIC</p>
                                <p>POSITIONING</p>
                            </div>
                        </div>
                        <div class="read-more">
                            <router-link to="/about/index" class="more-link">READ MORE</router-link>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="pages page-2 animation">
                        <div class="page-2-content">
                            <div class="earth">
                                <img src="../static/images/page-2-earth.png"/>
                            </div>
                            <div class="page-text">
                                <p>Trout & Partners is one of the most prestigious</p>
                                <p>marketing firms with headquarters in </p>
                                <p>Old Greenwich, Connecticut, USA and offices in 20</p>
                                <p>countries. </p>
                            </div>
                        </div>
                        <div class="read-more">
                            <router-link to="/about/index" class="more-link">READ MORE</router-link>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="pages page-3 animation">
                        <div class="page-3-content">
                            <div class="c-third-man">
                                <div class="c-f-title">Jack Trout</div>
                                <span class="c-line"></span>
                                <div class="c-man-info">
                                    <div class="man-pic">
                                        <img
                                                src="../static/images/tp-JackTrout.png"
                                                alt="Jack Trout"
                                                title="Jack Trout"
                                                width="100%"
                                                height="100%"
                                        />
                                    </div>
                                    <div class="man-called">
                                        <span class="before"> </span>
                                        <span>FATHER OF POSITIONING</span>
                                    </div>
                                </div>
                            </div>
                            <div class="c-third-lift">
                                <ul class="life-list">
                                    <li class="life-item">
                                        <div class="l-name">THE BATTLE FOR YOUR MIND</div>
                                        <div class="l-time">1981</div>
                                    </li>
                                    <li class="life-item">
                                        <div class="l-name">THE NEW POSITIONING</div>
                                        <div class="l-time">1996</div>
                                    </li>
                                    <li class="life-item">
                                        <div class="l-name">
                                            REPOSITIONING: MARKETING IN AN ERA OF COMPETITION, CHANGE AND CRISIS
                                        </div>
                                        <div class="l-time">2010</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="read-more">
                            <router-link to="/positioning/introduce" class="more-link">READ MORE</router-link>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="pages page-4 animation">
                        <div class="page-4-content">
                            <div class="c-fourth-company">
                                <ul class="company-show">
                                    <li class="company-item">
                                        <div class="company-icon hp"></div>
                                        <div class="company-info">
                                            <div class="company-name">Hewlett-Packard</div>
                                            <p class="company-txt">
                                                For HP we have worked with their Professional Services ...
                                            </p>
                                            <a href="" class="company-share"></a>
                                        </div>
                                    </li>
                                    <li class="company-item">
                                        <div class="company-icon ibm"></div>
                                        <div class="company-info">
                                            <div class="company-name">IBM</div>
                                            <p class="company-txt">
                                                For IBM we helped them develop a positioning strategy for
                                                ...
                                            </p>
                                            <a href="" class="company-share"></a>
                                        </div>
                                    </li>
                                    <li class="company-item">
                                        <div class="company-icon intel"></div>
                                        <div class="company-info">
                                            <div class="company-name">INTEL</div>
                                            <p class="company-txt">
                                                We were asked to review the marketing strategy of Intel’s
                                                ...
                                            </p>
                                            <a href="" class="company-share"></a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="c-fourth-introduce">
                                <div class="c-f-title">CONSULTING</div>
                                <span class="c-line"></span>
                                <p class="c-f-introduce">
                                    Trout & Partners has done “Positioning strategy” for companies
                                    all over the world from caskets to computers and everything in
                                    between.
                                </p>
                            </div>
                            <div class="read-more">
                                <router-link to="/service/consulting" class="more-link">READ MORE</router-link>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="pages page-5 animation">
                        <div class="page-5-content">
                            <swiper :options="swiperOptionFive" ref="fiveSwiper">
                                <swiper-slide v-for="(item,index) in insightlist" :key="index">
                                    <div class="video-cover">
                                        <img :src="item.cover" />
                                    </div>
                                    <div class="descirble">
                                        <div class="news-title">{{item.title}}</div>

                                        <p class="news-words">{{item.desc}}</p>
                                        <div class="read-more">
                                            <router-link :to="{path:'/insights/details',query:{id:item.id}}" class="more-link">READ MORE</router-link>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="c-sixth-page">
                                <span class="page-arr-rt swiper-button-prev"></span>
                                <span class="page-number"><i>{{fiveIndex}}</i> / <i>{{insightlist.length}}</i></span>
                                <span class="page-arr-lt swiper-button-next"></span>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="pages page-6 animation">
                        <div class="page-6-content">
                            <div class="cover-img" v-for="(item,index) in newsList" v-if="index<3" :key="index" :style="{backgroundImage: 'url(' + item.cover + ')', backgroundSize:'cover'}">
                                <router-link :to="{path:'/news/details',query:{id:item.id}}">
                                    <div class="cover-content">
                                        <div class="cover-title">{{item.title}}</div>
                                        <div class="cover-date">{{item.up_time | formatDate}}</div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <bottom-app></bottom-app>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
    import headerApp from '@/components/headerApp.vue'
    import bottomApp from '@/components/bottomApp.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    export default {
        components: {
            swiper,
            swiperSlide,
            headerApp,
            bottomApp
        },
        data(){
            return{
                isShow:false,
                swiperOption: {
                    direction: 'vertical',
                    slidesPerView: 1,
                    height: window.innerHeight
                },
                swiperOptionFive:{
                    navigation: {
                        nextEl: '.swiper-button-prev',
                        prevEl: '.swiper-button-next',
                    },
                },
                fiveIndex:1,
                newsList:[],
                insightlist:[]
            }
        },
        filters: {
          formatDate: function (value) {
            var date = new Date(value*1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? ('0' + minute) : minute;
            second = second < 10 ? ('0' + second) : second;
            return y + '/' + m + '/' + d;
          }
        },
        methods:{

        },
        computed: {
            swiper() {
                return this.$refs.fiveSwiper.swiper
            }
        },
        mounted(){
            this.swiper.on('slideChangeTransitionEnd', () => {
                this.fiveIndex = this.swiper.activeIndex + 1 || 1
            });
        },
        created(){
            this.$api.insighList().then((res)=>{
                if(res){
                    this.insightlist = res.list || []
                }
            })
            this.$api.newsList().then((res)=>{
                if(res){
                    this.newsList = res.list || []
                }
            })
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-index{
        position: absolute;
        width: 100%;
        height: 100%;
        overflow: hidden;
        max-width: 750px;
        margin: 0 auto;
        .index-swiper,
        .swiper-container {
            width: 100%;
            height: 100%;
            overflow: hidden;
        }

        //公共
        .pages{
            padding:.4rem;
            height: 100%;
            text-align: left;
            box-sizing: border-box;
            overflow: hidden;
            .read-more{
                .more-link{
                    font-size: .28rem;
                    color: #090909;
                    font-weight: bold;
                    &:after{
                        content: "";
                        display: inline-block;
                        position: relative;
                        left: 0.4rem;
                        top: 0.04rem;
                        width: 0.38rem;
                        height: 0.28rem;
                        background: url(../assets/imgs/tp-icon-arrow.png) no-repeat center center;
                        background-size: 100% auto;
                    }
                    &:hover{
                        color: #e00000!important;
                        &:after{
                            content: "";
                            display: inline-block;
                            background: url(../assets/imgs/tp-icon-arrow-hover.png) no-repeat center center;
                            background-size: 100% auto;
                        }
                    }
                }
            }
            .page-text{
                &:after{
                    content: '';
                    width: 3.2rem;
                    height: .12rem;
                    display: inline-block;
                    background: #e00000;
                }
            }
        }

        //第一屏
        .page-1{
            background: url("../assets/imgs/page_01_bg.png") no-repeat bottom center;
            background-size: contain;
            .page-text{
                text-align: left;
                padding-top: 3rem;
                font-size: .6rem;
                color: #000000;
                font-weight: bold;
                position: relative;
            }
        }

        //第二屏
        .page-2{
            .page-2-content{
                padding-top: 1rem;
                .earth{
                    height: 7.5rem;
                    display: block;
                    margin: 0 auto;
                    img{
                        width: 100%;
                    }
                }
                .page-text{
                    font-size: .28rem;
                    color: #000000;
                    padding-bottom: .8rem;
                    line-height: .5rem;
                    &:after{
                        display: none;
                    }
                }
            }
        }

        //第三屏
        .page-3{
            .page-3-content{
                padding-top: 1rem;
                .c-third-man {
                    .c-f-title {
                        line-height: .8rem;
                        font-size: .6rem;
                        font-weight: bold;
                        color: #000;
                        white-space: nowrap;
                        letter-spacing: .1rem;
                    }
                    .c-line {
                        display: block;
                        width: 3.2rem;
                        height: .12rem;
                        background: #e00000;
                        margin-bottom: .26rem;
                    }
                    .c-man-info {
                        position: relative;
                        width: 3.1rem;
                        .man-pic {
                            width: 3.1rem;
                            height: 3.9rem;
                        }
                        .man-called {
                            position: absolute;
                            left: 100%;
                            top: 40%;
                            font-size: .24rem;
                            font-weight: bold;
                            color: #000;
                            padding-left: 1.1rem;
                            white-space: normal;
                            .before{
                                width: 1rem;
                                content: "";
                                position: absolute;
                                left: 0;
                                top: 0.15rem;
                                height: 0.02rem;
                                background: #e00000;
                            }
                        }
                    }
                }
                .c-third-lift {
                    padding-top: .7rem;
                    .life-list {
                        margin-bottom: .54rem;
                        .life-item {
                            margin-bottom: .3rem;
                            .l-name {
                                line-height: .44rem;
                                font-size: .28rem;
                                font-weight: bold;
                                color: #000;
                            }
                            .l-time {
                                line-height: .36rem;
                                font-size: .18rem;
                                color: #999;
                                &:after {
                                    content: "";
                                    display: inline-block;
                                    vertical-align: middle;
                                    width: 1.4rem;
                                    height: .02rem;
                                    margin-left: .1rem;
                                    background: #b8b8b8;
                                }
                            }
                        }
                    }
                }
            }
        }

        //第四屏
        .page-4{
            .company-show {
                display: inline-block;
                font-size: 0;
                white-space: nowrap;
                padding-top: 1.8rem;
                .company-item {
                    display: inline-block;
                    vertical-align: top;
                    height: 5.6rem;
                    margin: 0 .1rem;
                    transition: all .2s ease-in-out;
                    &:hover{
                        transform: translate(0,-.2rem);
                        transition: all .2s ease-in-out;
                        /*.company-info {*/
                            /*display: block;*/
                        /*}*/
                    }
                    .company-icon {
                        display: inline-block;
                        width: 2rem;
                        height: 2rem;
                        background: #b8bdc2;
                        &:hover {
                            filter: invert(100%);
                        }
                        &.hp {
                            background: url(../static/images/tp-icon-hp.png) no-repeat;
                            background-size: cover;
                        }
                        &.ibm {
                            position: relative;
                            top: .8rem;
                            background: url(../static/images/tp-icon-ibm.png) no-repeat;
                            background-size: cover;
                        }
                        &.intel {
                            background: url(../static/images/tp-icon-intel.png) no-repeat;
                            background-size: cover;
                        }
                    }
                    .company-info {
                        display: none;
                        position: relative;
                        top: 0;
                        margin-top: 1.2rem;
                        text-align: center;
                        white-space: normal;
                        .company-name {
                            font-size: .24rem;
                            font-weight: bold;
                            color: #000;
                        }
                        .company-txt {
                            max-width: 3.2rem;
                            line-height: .34rem;
                            font-size: .18rem;
                            color: #000;
                            margin: 0 auto .3rem;
                        }
                    }
                }
            }
            .c-fourth-introduce {
                padding-bottom:1rem;
                .c-f-title {
                    font-size: .3rem;
                    font-weight: bold;
                    line-height: .8rem;
                }
                .c-line {
                    display: block;
                    height: 2px;
                    width: 3.2rem;
                    line-height: .8rem;
                    background: #e00000;
                    margin-bottom: .26rem;
                }
                .c-f-introduce {
                    font-size: .28rem;
                    color: #000;
                    word-break: break-word;
                    line-height: .6rem;
                }
            }
        }

        //第五️屏
        .page-5{
            .page-5-content{
                height: 10rem;
                margin-top: 1rem;
                box-shadow: 0 0 30px rgba(0,0,0,.2);
                background:#fff;
                .c-sixth-page {
                    position: absolute;
                    left: 50%;
                    bottom: .6rem;
                    transform: translateX(-50%);
                    font-size: .16rem;
                    color: #333;
                    white-space: nowrap;
                    .page-arr-lt {
                        display: inline-block;
                        width: .78rem;
                        height: .14rem;
                        background: url(../assets/imgs/tp-arr-long-lt.png) no-repeat;
                        background-size: cover;
                        margin-right: .2rem;
                        cursor: pointer;
                        right:.3rem;
                        &:hover {
                            display: inline-block;
                            width: .78rem;
                            height: .14rem;
                            background: url(../assets/imgs/tp-arr-long-lt-hover.png) no-repeat;
                            background-size: cover;
                            margin-right: .2rem;
                            cursor: pointer;
                        }
                    }
                    .page-number{
                        position: absolute;
                        left: -10px;
                        top: -26px;
                        font-size: 12px;
                    }
                    .page-arr-rt {
                        display: inline-block;
                        width: .78rem;
                        height: .14rem;
                        background: url(../assets/imgs/tp-arr-long-rt-hover.png) no-repeat;
                        background-size: cover;
                        margin-left: .2rem;
                        cursor: pointer;
                        left:.3rem;
                        &:hover {
                            display: inline-block;
                            width: .78rem;
                            height: .14rem;
                            background: url(../assets/imgs/tp-arr-long-rt.png) no-repeat;
                            background-size: cover;
                            margin-left: .2rem;
                            cursor: pointer;
                        }
                    }
                }
                .video-cover{
                    height: 3.5rem;
                    background: #666666;
                    position: relative;
                    img{
                        width:100%;
                        height:100%;
                    }
                }
                .descirble{
                    padding: .6rem .4rem;
                    .news-title {
                        line-height: .5rem;
                        font-size: .3rem;
                        color: #181818;
                        margin-bottom: .1rem;
                    }
                    .news-brief {
                        line-height: .36rem;
                        font-size: .22rem;
                        color: #999;
                        margin-bottom: .2rem;
                    }
                    .news-words {
                        line-height: .36rem;
                        font-size: .24rem;
                        color: #666;
                        margin-bottom: .5rem;
                    }
                }
            }
        }

        //第六屏
        .page-6{
            .page-6-content{
                padding-top: .6rem;
                a{
                    color:#fff;
                }
                .cover-img{
                    position:relative;
                    height: 3.6rem;
                    background-size: cover;
                    color: #fff;
                    border-bottom: .06rem solid #ed1d25;
                    .cover-content{
                       position: absolute;
                       left: 0;
                       bottom: 0rem;
                       box-sizing: border-box;
                       padding: 0 .3rem;
                       color:#fff;
                       font-weight: bold;
                    }
                    a{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        padding: .3rem;
                        box-sizing: border-box;
                        background: rgba(0,0,0,.3);
                    }
                    .cover-title{
                        font-size: .30rem;
                        font-weight: bold;
                    }
                    .cover-date{
                        font-size: .24rem;
                        height: .7rem;
                        line-height: .7rem;

                    }
                }
                .cate-list{
                    font-size: 0;
                    line-height: 0;
                    li{
                        width: 50%;
                        color: #fff;
                        font-size: .28rem;
                        padding: 0 .3rem;
                        text-align: center;
                        display: inline-block;
                        box-sizing: border-box;
                        background: #d2d2d2;
                        font-weight:bold;
                        position: relative;
                        height: 1.5rem;
                        vertical-align: top;
                        &:nth-child(2){
                            background: #7d7d7d;
                        }
                        &:nth-child(3){
                            background: #7d7d7d;
                        }
                        a{
                            display:block;
                            position:absolute;
                            top:0;
                            left:0;
                            width:100%;
                            height:100%;
                            background:rgba(0,0,0,.5);
                        }
                        .txt{
                            display: inline-block;
                            line-height: 24px;
                            vertical-align: middle;
                        }
                    }
                }
                .fifth-bottom{
                    height: 3.5rem;
                    line-height: 3.5rem;
                    text-align: center;
                    color: #fff;
                    background: #535353;
                    padding:0 .3rem;
                    font-weight:bold;
                    .txt{
                        display: inline-block;
                        line-height: 24px;
                        vertical-align: middle;
                    }
                }
            }
        }
    }
</style>
